import { IsNotEmpty, IsOptional, IsUUID } from 'class-validator';

export class ActionEventTypeDto {
  @IsUUID()
  @IsNotEmpty()
  eventTypeId: string;

  @IsOptional()
  @IsUUID()
  @IsNotEmpty()
  validatorId?: string;

  @IsOptional()
  @IsUUID()
  @IsNotEmpty()
  companyId: string;
}
